//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {addToClipboard} from "~/helpers/clipboard";

export default {
  name: "InfoCard",

  data: function () {
    return {
      textBox: ''
    }
  },

  props: {
    info: {
      type: Object,
      default: {},
      required: false,
    },
    cfgs: {
      type: Object,
      default: {},
      required: false,
    },
  },

  computed: {
    title: function () {
      return this.info.title;
    },
    message: function () {
      return this.info.text;
    },

    isShowTestingApiMethod: function () {
      return Boolean(String(this.cfgs?.show_test_form) === '1')
    },
  },

  components: {
    TestingApiMethod: () => import("~/components/api-docs/TestingApiMethod.vue")
  },

  mounted: function () {
    const elements = this.$refs.refRoot.querySelectorAll('.--copy-content');
    const self = this;
    elements.forEach((el) => {
      el.onclick = self.copyString;
    });
  },

  methods: {
    copyLink: async function () {
      const pathname = String(window.location?.href || "").split("#")?.[0];
      await addToClipboard([pathname, this.info.keySection].join('#'));
      this.$toast.success(this.$t('documentationApi.successLinkCopy'));
    },
    copyString: async function (event) {
      const _text = event.target.innerText;
      await addToClipboard(_text);
      this.$toast.success(this.$t('copyToBuffer.success'));
    },
  },
}
